import { useQuery } from '@tanstack/react-query';
import { ImageType } from '../models';

const imageTypeWeights = {
  '8x10': 0,
  '5x7': 600,
  '3x5': 700,
  wallets: 900,
  file: 1000,
  download: 1000,
};

function sorter(imageType1, imageType2) {
  const splitName1 = imageType1.name.split(' ');
  const splitName2 = imageType2.name.split(' ');
  const weight1 = imageTypeWeights[splitName1[splitName1.length - 1].toLowerCase()];
  const weight2 = imageTypeWeights[splitName2[splitName2.length - 1].toLowerCase()];

  if (weight1 < weight2) return -1;

  return 1;
}

export default function useImageTypes(optionId) {
  return useQuery(['imageTypes', optionId], () => (
    ImageType
      .includes(['component'])
      .where({ optionId })
      .all()
      .then((res) => (
        res
          .data
          .filter((imageType) => !imageType.classname.includes('classpicture'))
      ))
  ), { placeholderData: [], enabled: !!optionId });
}
